import { Grid } from "@mui/material"
import React from "react"
import { BSFilterContextProvider } from "../../../../../../../../../../components/charts/filters/BSFilterContext"
import { BSDashboardSelectionContextProvider } from "../../../../../../../../../../components/charts/selection/BSDashboardSelectionContext"
import { BSBuildingResult } from "../../../../../../../../../../core/dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { BSMaterialResultDashboard } from "../../../../../../../../../../core/dto/beem-shot/BSMaterialResult/BSMaterialResultDashboard"
import { IcConstructionBottomPanel } from "./panels/IcConstructionBottomPanel"
import { IcConstructionMiddleLeftPanel } from "./panels/IcConstructionMiddleLeftPanel"
import { IcConstructionMiddleRightPanel } from "./panels/IcConstructionMiddleRightPanel"
import { IcConstructionTopLeftPanel } from "./panels/IcConstructionTopLeftPanel"
import { IcConstructionTopRightPanel } from "./panels/IcConstructionTopRightPanel"

interface IProps {
  bsBuildingResult: BSBuildingResult
  allBSMaterialResult: BSMaterialResultDashboard[]
  dashboardRef: React.MutableRefObject<HTMLDivElement | null>
}

export function BSIcConstructionTab({
  bsBuildingResult,
  allBSMaterialResult,
  dashboardRef,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <BSFilterContextProvider allBSMaterialResult={allBSMaterialResult}>
      <BSDashboardSelectionContextProvider>
        <Grid container ref={dashboardRef} columnSpacing={2} rowGap={2} sx={{ pt: 2 }} alignItems="stretch">
          {/* Top panel */}
          <Grid item xs={7}>
            <IcConstructionTopLeftPanel bsBuildingResult={bsBuildingResult} allBSMaterialResult={allBSMaterialResult} />
          </Grid>
          <Grid item xs={5}>
            <IcConstructionTopRightPanel allBSMaterialResult={allBSMaterialResult} />
          </Grid>

          <Grid item xs={7}>
            <IcConstructionMiddleLeftPanel allBSMaterialResult={allBSMaterialResult} />
          </Grid>
          <Grid item xs={5}>
            <IcConstructionMiddleRightPanel allBSMaterialResult={allBSMaterialResult} />
          </Grid>

          <Grid item xs={12}>
            <IcConstructionBottomPanel allBSMaterialResult={allBSMaterialResult} />
          </Grid>
        </Grid>
      </BSDashboardSelectionContextProvider>
    </BSFilterContextProvider>
  )
}
